<template>
    <PlanbordCommentCell>
        <div class="comment-cell-content">
            <div class="comment-content" v-if="resource.employment && resource.employment.comment && resource.employment.comment.content.length">
                {{ resource.employment.comment.content }}
            </div>
            <div class="no-comment" v-else></div>
            <div class="edit-button" @click="openCommentEditor">
                <i class="icon edit" />
            </div>
        </div>
    </PlanbordCommentCell>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import EmploymentCommentModal from '@/components/modals/EmploymentCommentModal.vue';
    import {ResourceWithKeyedByDateObjects} from '@/types/api-object-extensions';
    import PlanbordCommentCell from '@/components/Planbord/PlanbordCommentCell.vue';

    @Component({
        components: {
            EmploymentCommentModal,
            PlanbordCommentCell,
        },
    })
    export default class ResourceCommentCell extends Vue {
        @Prop({required: true}) public resource!: ResourceWithKeyedByDateObjects;

        public openCommentEditor(): void {
            if (this.resource && this.resource.employment) {
                const commentId: number | undefined = this.resource.employment.comment ? this.resource.employment.comment.id : undefined;
                /** @see EmploymentCommentModal.openModal() */
                // @ts-expect-error TS2339
                EmploymentCommentModal.__vfdConstructor.openModal(this.resource!.employment, undefined, commentId);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .comment-content {
        border-radius: 10px;
        color: var(--comment-color);
        background: var(--comment-background);
        hyphens: auto;
        overflow-wrap: break-word;
        padding: 0.2rem 0.4rem;
        margin: 0.1rem;
    }

    .edit-button {
        cursor: pointer;

        .icon {
            background: var(--button-teal);
        }
    }

    .comment-cell-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>
